module.exports = __webpack_public_path__ + "img/组 11467.f4b879d0.png";